export default {
  path: 'service-category',
  component: () => import('@/views/settingSystem/setting-router.vue'),
  children: [
    {
      path: '',
      name: 'ServiceCategoryList',
      component: () => import('@/views/settingSystem/pages/service-category/ServiceCategoryList.vue'),
      meta: {
        name: 'ตั้งค่าระบบ',
        icon: '/icons/setting.svg'
      }
    },
    {
      path: 'create',
      name: 'ServiceCategoryCreate',
      component: () => import('@/views/settingSystem/pages/service-category/ServiceCategoryCreate.vue'),
      meta: {
        name: 'ตั้งค่าระบบ',
        icon: '/icons/setting.svg'
      }
    },
    {
      path: 'edit/:id',
      name: 'ServiceCategoryEdit',
      component: () => import('@/views/settingSystem/pages/service-category/ServiceCategoryEdit.vue'),
      meta: {
        name: 'ตั้งค่าระบบ',
        icon: '/icons/setting.svg'
      }
    }
  ]
}
